$(document).ready(function(){
	 //new invite
    $(document).on("click", ".stepper-wrapper .newinvite-btn", function() {
        $(".stepper-circle-wrapper").removeClass("complete").addClass('disable');
        $(".stepper-line-wrapper").removeClass('active');
        $(".stepper-circle-wrapper").eq(0).removeClass('disable');
        $('.stepper-wrapper h4 em').text("1");
        $(this).closest('.step-form').fadeOut(function() {
            $('.step1-wrapper').fadeIn()
        });

    });


    //stepper button next
    $(document).on("click", ".step-btn-next", function() {

        $('body').on("change",'.dead-line-wrap input:radio', function() {
            if ($(this).is(":checked")) {
                $(".label-wrap label").removeClass('checked')
                $(this).closest("label").addClass('checked')
            }
        });

        var get_index = parseInt($(this).closest('.step-form').attr("data-index"), 10);
        var step_no = get_index + 2;
        $('.stepper-wrapper h4 em').text(step_no);
        $(this).closest('.step-form').fadeOut(function() {
            var show_current_step = get_index + 2;
            $(".step" + show_current_step + "-wrapper").fadeIn();

        });
        $(".stepper-line-outer .stepper-circle-wrapper").eq(get_index).addClass('complete').next().addClass('active');
        if (get_index == 4) {
            setTimeout(function() {
                $(".stepper-line-outer .stepper-circle-wrapper").eq(get_index + 1).removeClass('disable').addClass('complete');
            }, 500);
        } else {
            setTimeout(function() {
                $(".stepper-line-outer .stepper-circle-wrapper").eq(get_index + 1).removeClass('disable');
            }, 500);

        }

    });


    //step button previous
    $(document).on("click", ".step-btn-prev", function() {
        var get_index = parseInt($(this).closest('.step-form').attr("data-index"), 10);
        var step_no = get_index;
        $('.stepper-wrapper h4 em').text(step_no);
        $(this).closest('.step-form').fadeOut(function() {
            var show_current_step = get_index;
            $(".step" + show_current_step + "-wrapper").fadeIn();
        });
        $(".stepper-line-outer .stepper-circle-wrapper").eq(get_index).addClass('disable');
        $(".stepper-line-outer .stepper-circle-wrapper").eq(get_index - 1).next().removeClass('active');
        setTimeout(function() {
            $(".stepper-line-outer .stepper-circle-wrapper").eq(get_index - 1).removeClass('complete');
        }, 500);
    });

    //stepper step3
    $(document).on('click', ".card-header .hover-btn ", function(event) {
        $(this).closest('.step-form').find(".step-btn-next").click()
    });
})